var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReflectionUnsel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.99995L2 21.9999M18 14.9999H9M6.6 18.9999H13.3373C13.5818 18.9999 13.7041 18.9999 13.8192 18.9723C13.9213 18.9478 14.0188 18.9074 14.1083 18.8526C14.2092 18.7907 14.2957 18.7043 14.4686 18.5313L19.5 13.4999C19.739 13.261 19.8584 13.1415 19.9546 13.0357C22.0348 10.7473 22.0348 7.25262 19.9546 4.96418C19.8584 4.85839 19.739 4.73891 19.5 4.49995C19.261 4.26099 19.1416 4.1415 19.0358 4.04535C16.7473 1.96519 13.2527 1.96519 10.9642 4.04535C10.8584 4.1415 10.739 4.26098 10.5 4.49994L5.46863 9.53132C5.29568 9.70427 5.2092 9.79075 5.14736 9.89166C5.09253 9.98114 5.05213 10.0787 5.02763 10.1807C5 10.2958 5 10.4181 5 10.6627V17.3999C5 17.96 5 18.24 5.10899 18.4539C5.20487 18.6421 5.35785 18.7951 5.54601 18.891C5.75992 18.9999 6.03995 18.9999 6.6 18.9999Z",
    stroke: "#2F80ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReflectionUnsel);
export default __webpack_public_path__ + "static/media/ReflectionUnsel.555e405e729b7127fc536a1d427a32c3.svg";
export { ForwardRef as ReactComponent };